import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheGlowStandard from "./sections/TheGlowStandard";
import RealResultsRealPeople from "./sections/RealResultsRealPeople";
import ClientPerspectives from "./sections/ClientPerspectives";
import ExpertKnowledgeBase from "./sections/ExpertKnowledgeBase";
import SecureYourAppointment from "./sections/SecureYourAppointment";
import Contact from "./sections/Contact";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheGlowStandard />
      <RealResultsRealPeople />
      <ClientPerspectives />
      <ExpertKnowledgeBase />
      <SecureYourAppointment />
      <Contact />
      <Footer />
    </div>;
}